import React from 'react'
import { Paper, Stack, Typography } from '@mui/material'
import { toLocaleStringIn } from '../../../util/general'
import { formatLargeNumber } from '../../../util/screener'

export type ScreenerChartTooltipProps = {
    visible: boolean
    x: number
    y: number
    security: {
        symbol: string
        logoUrl?: string
        code: string
    }
    price?: number
    volume?: number
    isProfit?: boolean
    time?: number
}

const ScreenerChartTooltip: React.FC<ScreenerChartTooltipProps> = ({
    visible,
    x,
    y,
    security,
    price,
    volume,
    isProfit,
    time
}) => {
    if (!visible || price === undefined) return null
    const priceColor = isProfit === undefined ? 'text.primary' : isProfit ? 'var(--green-text-color)' : 'var(--red-text-color)'
    const dateObj = time ? new Date(time * 1000) : null
    const formattedDate = dateObj ? dateObj.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    }) : ''
    const formattedTime = dateObj ? `${dateObj.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    })} UTC+5:30` : ''

    return (
        <Paper
            sx={{
                position: 'absolute',
                left: x + 10,
                top: y + 10,
                zIndex: 1000,
                padding: 1.5,
                pointerEvents: 'none',
                minWidth: '200px',
                boxShadow: 3
            }}
        >
            <Stack spacing={0.2} justifyContent="center" >

                <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                    <Typography fontSize={'13px'}>
                        {security.symbol}
                    </Typography>
                    <Typography variant="caption" fontWeight="medium" sx={{ color: priceColor }}>
                        {toLocaleStringIn(price)}
                    </Typography>
                </Stack>
                <Stack >
                    {volume !== undefined && (
                        <Stack direction="row" justifyContent="center" gap={1}>
                            <Typography fontSize={'13px'}>
                                Vol
                            </Typography>
                            <Typography variant="caption" fontWeight="medium" sx={{ color: priceColor }}>
                                {formatLargeNumber(volume)}
                            </Typography>
                        </Stack>
                    )}
                </Stack>
                {time && (
                    <Stack alignItems="center">
                        <Typography fontSize={'12px'} color="text.secondary">
                            {formattedDate}
                        </Typography>
                        <Typography fontSize={'12px'} color="text.secondary">
                            {formattedTime}
                        </Typography>
                    </Stack>
                )}
            </Stack>
        </Paper>
    )
}

export default ScreenerChartTooltip
